// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-select-btn[data-v-a5ec9086]{display:flex;align-content:center;align-items:center;width:300px}.project-select-btn span[data-v-a5ec9086]{margin:0 5px}.project-select-btn .project-select-btn__right-icon[data-v-a5ec9086]{margin-left:auto}.project-select-btn .project-select-btn__label[data-v-a5ec9086]{overflow:hidden;text-overflow:ellipsis}.project-select-btn__popper[data-v-a5ec9086]{width:300px;height:400px;overflow:hidden}", ""]);
// Exports
module.exports = exports;
